import Staff from "../../../components/staffModule/staff/Staff"

function StaffPage() {
    return (
        <>
            <Staff />
        </>
    )
}
export default StaffPage